<template>
  <div>
    <el-table
      :data='tableData'
      :highlight-current-row='true'
      stripe
      v-bind='$attrs' v-on='$listeners'
      row-class-name='pointer'
      @sort-change='handleChangeSort'
      border>
      <el-table-column label='导入结果' prop='err_msg' align='center' width='120' show-overflow-tooltip>
        <template slot-scope='{row}'>
          <span :class='row.row_class'> {{row.err_msg||''}}</span>
        </template>
      </el-table-column>
      <template v-for='(col,index) in columns'>
        <el-table-column :prop='`${col.property||col.prop}`' :key='index' :label='`${col.label}`'
                         :min-width='`${col.width}`'
                         align='center' header-align='center'
                         :sortable='col.sortable?col.sortable:false'
                         show-overflow-tooltip>
          <template slot-scope='{row}'>
            <span @click='handleCopy(row[col.prop])'>{{ row[col.prop] }}</span>
          </template>
        </el-table-column>
      </template>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'ImportTablePanel',
  props: {
    tableData: {
      type: Array
    },
    columns: {
      type: Array
    },
    showDept: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    selectRow() {
      this.$emit('selectRow')
    },
    handleCopy(val) {
      //复制到剪切板
      navigator.clipboard.writeText(val)
        .then(() => {
          this.msgSuccess('复制成功')
        }).catch(err => console.error('复制失败:', err))
    },
    handleChangeSort({ prop, order }) {
      const orderSort = {}
      if (order) {
        orderSort[prop] = order === 'descending' ? 'desc' : 'asc'
      }
      this.$emit('handleChangeSort', orderSort)
    }
  }
}
</script>
<style>
.default{
  padding: 2px 5px;
  border: var(--primary) 1px dashed;
}

.success{
  padding: 2px 5px;
  border: var(--success) 1px solid;
  color: var(--success);
  border-radius: 5px;
}
.error{
  padding: 2px 5px;
  border: var(--danger) 1px dashed;
  color: var(--danger);
  border-radius: 5px;
}
</style>

